import { BudgetReferenceValueResponse } from '../../../../models/BudgetReferenceValueResponse';
import { Fragment } from 'react';
import MeterForecastInformation from './MeterForecastInformation';
import { useTranslation } from 'react-i18next';
import { useWizard } from 'react-use-wizard';

export interface MeterForecastWizardStep1Props {
  budgetReference?: BudgetReferenceValueResponse;
}
export default function MeterForecastWizardStep1({
  budgetReference,
}: MeterForecastWizardStep1Props) {
  const { t } = useTranslation();
  const { nextStep } = useWizard();

  return (
    <Fragment>
      <MeterForecastInformation budgetReference={budgetReference} />
      <div className="meter-forecast__wizard__footer">
        <a
          href={t('common.faq.link')}
          target="_blank"
          className="btn btn--secondary"
          rel="noreferrer"
        >
          {t('overview.meter.detail.forecast.question')}
        </a>
        <button onClick={nextStep} className="btn btn--primary">
          {t('common.next')}
        </button>
      </div>
    </Fragment>
  );
}
